import { Outlet } from "react-router-dom";

export function PublicLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
